import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/admin", label: "Оборудование" },
  { to: "/admin/requests", label: "Запросы" },
];

export default function AdminTabs() {
  const { pathname } = useLocation();

  return (
    <div className="mb-8 flex gap-8 border-b border-steel-200">
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`-mb-px border-b-2 pb-3 text-xs font-semibold uppercase tracking-wide2 transition-colors duration-200 ease-engineered ${
            pathname === tab.to
              ? "border-accent text-ink"
              : "border-transparent text-steel-400 hover:text-steel-600"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
}
